import clsx from 'clsx';
import React from 'react';
import useStyles from './ValueLabelStyles';
var ValueLabel = function (_a) {
    var value = _a.value, children = _a.children, className = _a.className;
    var styles = useStyles();
    return React.cloneElement(children, {
        className: clsx(children.props.className, styles.open, styles.thumb),
    }, React.createElement("span", { className: clsx(styles.offset, className) },
        React.createElement("span", { className: styles.circle },
            React.createElement("span", { className: styles.label }, value))));
};
export default ValueLabel;
